import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { Button, Modal } from '@/components';
import { useTranslation } from '@/i18n/client';

interface SeckillModalProps {
  isOpen: boolean;
  onClose: () => void;

  data: AnyProps;

  onOk?: () => void;

  lang: string;

  classnames?: string;
}

export const SeckillModal: React.FC<SeckillModalProps> = ({
  isOpen,
  onClose,
  data = {
    image: '',
  },
  onOk,
  lang,
  classnames = '',
}) => {
  const { t } = useTranslation(lang);
  return (
    <Modal background="bg-gradient-to-b from-[#FBB] to-white" isOpen={isOpen} onClose={onClose}>
      <div className="w-100%">
        <div className="flex justify-center align-center text-2xl font-bold pb-6">
          🎉恭喜！秒殺成功
        </div>
        <div className="p-4 text-sm rounded-2xl bg-gradient-to-t from-[rgba(255,223,57,0)] to-[rgba(255,223,57,0.2)] bg-white">
          <div className="flex  font-medium mt-4.5">
            <div className="w-16 h-16">
              {data?.image && data.image !== '' && data.image !== null && (
                <Image src={data.image} alt="image" width={64} height={64} />
              )}
            </div>
            <div className="w-31.5 h-100%">
              <p>{data?.productName}</p>
              <p>免費代金券</p>
            </div>
          </div>
          <div>
            <span>價值：</span>
            <span className="font-bold text-[18px] leading-6.5 text-btn-red">
              ${data?.payPrice}
            </span>
          </div>
        </div>
        <div className="pt-18 flex justify-between">
          <Button
            className="w-32  text-base rounded-full border-primary font-medium"
            type="link"
            size="sm"
            onClick={onClose}
          >
            {t('go-it')}
          </Button>
          <Button
            className="w-32 text-white text-base rounded-full"
            type="gradual"
            size="sm"
            onClick={onOk}
          >
            {t('go-check')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
